import React, { useContext, useState } from 'react';
import GlobalVariables from './GlobalVariables';

export const GlobalContext = React.createContext<GlobalVariables | null>(null);

export const useGlobalData = (): GlobalVariables => {
  const globalVariables = useContext(GlobalContext);
  if (!globalVariables) {
    throw new Error('useGlobalData must be used inside GlobalProvider');
  }
  return globalVariables;
};

export type GlobalProviderProps = {
  children: React.ReactNode;
};

export const GlobalProvider = ({ children }: GlobalProviderProps): JSX.Element => {
  const [isOnEnrollment, setIsOnEnrollment] = useState<boolean>(false);
  return (
    <GlobalContext.Provider
      value={{
        isOnEnrollment,
        setIsOnEnrollment,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
